module.exports = __webpack_public_path__ + "img/tuurro.inside.b.981609f1.png";